import { http } from './config';

export default {
  profile: vibbrante_id =>
    http({
      method: 'get',
      url: 'vibbrantes/' + vibbrante_id,
    }),
  freelancer: token =>
    http({
      method: 'get',
      url: 'freelancers/' + token,
    }),
  confirm: (freelancer, token) =>
    http({
      method: 'put',
      url: 'freelancers/' + token,
      data: {
        freelancer,
      },
    }),
  privacy: () =>
    http({
      method: 'get',
      url: 'documents/privacy',
    }),
  privacyByType: type =>
    http({
      method: 'get',
      url: 'documents/privacy/' + type,
    }),
  terms: () =>
    http({
      method: 'get',
      url: 'documents/terms',
    }),
};



// WEBPACK FOOTER //
// ./src/api/public.js